import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { ClaimIcon, FilesIcon, PaymentIcon, PhysicianIcon, TransactionIcon } from '../helpers/Icons';
import ProfileCard from './ProfileCard';
import '../styles/sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const links = [
    { path: '/dashboard/claims', label: 'Claims', Icon: ClaimIcon },
    { path: '/dashboard/physician', label: 'Physician', Icon: PhysicianIcon },
    { path: '/dashboard/files', label: 'Files', Icon: FilesIcon },
    { path: '/dashboard/payments', label: 'Payments', Icon: PaymentIcon },
  ];

  return (
    <div className="flex h-screen relative">
      <div className={`bg-[#F7F7F9] relative transition-all duration-300 ${collapsed ? 'w-16' : 'w-52'}`}>
        <div className="flex items-center p-4 mt-4">
          {!collapsed ? (
            <>
              <TransactionIcon w="60" h="60" />
              <span className="ml-2 leading-5 text-[#8650e3] font-semibold font-lato text-[16px]">
                TRANSACTION MANAGER
              </span>
            </>
          ) : (
            <TransactionIcon w="50" h="50" />
          )}
        </div>
        <div className="mt-12 px-4 flex flex-col gap-4">
          {links.map(({ path, label, Icon }) => (
            <Tooltip title={collapsed ? label : ''} placement="right" arrow key={path}>
              <Link
                to={path}
                className={`flex items-center px-2 py-2 mt-2 rounded-lg cursor-pointer transition-all duration-200 ${
                  location.pathname === path
                    ? 'bg-[#E6E5E9] text-[#6E39CB] before:absolute before:left-0 before:h-10 before:w-1.5 before:bg-[#6E39CB] before:rounded-r-lg'
                    : 'bg-[#F7F7F9] text-[#263D50]'
                } hover:bg-[#E6E5E9] hover:text-purple-600 w-full`}>
                <Icon />
                {!collapsed && <span className="ml-2">{label}</span>}
              </Link>
            </Tooltip>
          ))}
        </div>
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 w-11/12">
          {!collapsed && <ProfileCard />}
        </div>
      </div>
      <IconButton
        className="absolute top-4 h-10 -left-5 text-white"
        sx={{ background: '#6E39CB', '&:hover': { background: '#7b4788' } }}
        onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <ChevronRight sx={{ color: '#F6F5FF' }} /> : <ChevronLeft sx={{ color: '#F6F5FF' }} />}
      </IconButton>
    </div>
  );
};

export default Sidebar;
